import { useCallback, useEffect, useState } from "react";
import { Formik, Form } from 'formik';
import { shallowEqual, useSelector } from "react-redux";
import FormikInput from "src/components/formik/FormikInput";
import FormikTextarea from "src/components/formik/FormikTextarea";
import { Delivery_YupSchema } from "./ViewPropTypes";
import { toast } from 'react-toastify';
import { deliverySaveAPI } from "src/api/ProjectApi";

const Render = (props) => {
    const {
        buttonText,
        values,
        isSubmitting,
        isValid, 
        dirty,   
        costLabel,  // New prop for dynamic label
    } = props;
    return (
        <>
            <Form autoComplete="disabled">
                <div className="row gy-3">
                    <div className="col-12">
                        <label className="form-label">{costLabel}</label> {/* Dynamic label */}
                        <div className="icon-field">
                            <FormikInput
                                name="value"
                                type="text"
                                className="form-control"
                                placeholder="0.00"
                            />
                            <span className="icon rupeeInr">
                                <i className="mdi mdi-currency-inr"></i>
                            </span>
                        </div>
                    </div>
                    <div className="col-12">
                        <label className="form-label">Comment</label>
                        <FormikTextarea
                            name="description"
                            className="form-control"
                            rows={4}
                            cols={50}
                            placeholder="Enter Comment..."
                            defaultValue={""}
                        />
                    </div>  
                    <div className="col-12">
                        <div className="d-flex gap-4 justify-content-between">
                            <button type="button" className="btn radius-8 px-20 py-11 w-100  btn-outline-neutral-900" data-bs-dismiss="modal" aria-label="Close">Back</button>
                            <button type="submit" 
                                disabled={!isValid || !dirty || isSubmitting} 
                                className="btn btn-primary radius-8 px-20 py-11 w-100" data-bs-dismiss="modal" aria-label="Close">{buttonText}</button>
                        </div>
                    </div>
                </div> 
            </Form>
        </>
    );
};

const VendorDeliverySavePopup = ({projectSearch, projectId, handleChange}) => {
    const { OAD_CMD_Details:Delivery_Details } = useSelector((state) => state.ProjectReducer, shallowEqual);
    const { user } = useSelector((state) => state.auth, shallowEqual);
    const { _id: userId } = user;
    
    const [headingText, setHeadingText] = useState('Add Vendor Delivery Cost');
    const [buttonText, setButtonText] = useState('Add');
    const [costLabel, setCostLabel] = useState('Enter Delivery cost to add'); // Dynamic label

    const defaultProps = { value: null, comment: "", projectId: projectId };

    useEffect(() => {
        if (Delivery_Details.mode === "add") {
            setHeadingText('Add Vendor Delivery Cost');
            setButtonText('Add');
            setCostLabel('Enter Vendor Delivery cost to add');
        } else {
            setHeadingText('Remove Vendor Delivery Cost');
            setButtonText('Remove');
            setCostLabel('Enter Vendor Delivery cost to remove');
        }
    }, [Delivery_Details]);

    const onSubmit = useCallback(async (values, formikUtils) => {
        try {
            values.by = userId;
            values.type = Delivery_Details.mode.toLowerCase();
            const response = await deliverySaveAPI(values);
            toast.success(response.data.message);
            handleChange(true)
        } catch (error) {
            toast.error("An error occurred while saving.");
        } finally {
            formikUtils.setSubmitting(false);
            formikUtils.resetForm();
            projectSearch();
        }
    }, [Delivery_Details.type, Delivery_Details.mode, userId, projectSearch]);

    return (
        <>
            <div className="modal fade cusmodl" id="uniqueCostModual" tabIndex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-sm modal-dialog-scrollable">
                    <div className="modal-content">
                        <div className="modal-header d-flex justify-content-center pb-0 border-0"> 
                            <h6 className="mb-2 fw-bold text-lg mb-0">{headingText}</h6>   
                        </div>
                        <div className="modal-body">
                            <Formik
                                onSubmit={onSubmit}
                                enableReinitialize
                                initialValues={defaultProps}
                                validationSchema={Delivery_YupSchema}
                            >
                                {(formikProps) => (
                                    <Render
                                        buttonText={buttonText}
                                        costLabel={costLabel} // Pass dynamic label
                                        {...formikProps}
                                    />
                                )}
                            </Formik>
                        </div> 
                    </div>
                </div>
            </div>
        </>
    );
};

export default VendorDeliverySavePopup; 